

















































































import QuoteStateMixin from '@/mixins/quoteState';
import auth from '@/mixins/auth';
import { mapActions } from 'vuex';
import { QuoteState } from '@/models/quote';
import { ErrorManager } from '@/models/error';
import ErrorAlert from '@/components/common/ErrorAlert.vue';
import mixins from '@/utils/mixins';

export default mixins(QuoteStateMixin, auth).extend({
  components: { ErrorAlert },
  name: 'QuoteDraftStateCard',

  computed: {
    getColor(): string {
      return 'draft';
    },

    getIcon(): string {
      return 'mdi-file-document-outline';
    },

    getString(): string {
      return 'Draft';
    },

    getActionText(): string {
      return 'Submit Quote';
    }
  },

  data: () => ({
    loading: false
  }),

  methods: {
    ...mapActions({
      setQuoteState: 'quote/setQuoteState'
    }),

    submit() {
      this.clearAllErrors();
      this.loading = true;
      const state = QuoteState.SUBMITTED;

      this.setQuoteState({ id: this.quote.number, state })
        .then(({ state }) => {
          this.$emit('state-changed:quote', {
            number: this.quote.number,
            revision: this.quote.revision,
            state: state
          });
        })
        .catch(error => {
          if (error.response) {
            if (error.response.data.detail) {
              this.detailErrorMessage = error.response.data.detail;
            }
          }
          this.errorMessage = ErrorManager.extractApiError(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    goToQuoteWizard() {
      this.$emit('openWizard');
    }
  }
});
